var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickList = function SvgTickList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-4);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -44.7,
    y1: 120.2,
    x2: 110.3,
    y2: -25.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -45.9,
    y1: 119,
    x2: 109.1,
    y2: -27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -11.6,
    y1: 155.4,
    x2: 143.4,
    y2: 9.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -7.5,
    y1: 159.8,
    x2: 147.5,
    y2: 13.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -8.7,
    y1: 158.4,
    x2: 146.3,
    y2: 12.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -9.9,
    y1: 157.2,
    x2: 145.1,
    y2: 11.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 24.4,
    y1: 193.6,
    x2: 179.4,
    y2: 47.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 28.5,
    y1: 198,
    x2: 183.5,
    y2: 52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 27.3,
    y1: 196.6,
    x2: 182.3,
    y2: 50.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 26.1,
    y1: 195.4,
    x2: 181.1,
    y2: 49.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 60.4,
    y1: 231.8,
    x2: 215.4,
    y2: 85.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 64.5,
    y1: 236.2,
    x2: 219.5,
    y2: 90.2,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.3,0c-15.4,0-27.9,12.5-27.9,27.9s12.5,27.9,27.9,27.9,27.9-12.5,27.9-27.9S68.7,0,53.3,0ZM53.3,49.5c-11.9,0-21.7-9.7-21.7-21.6,0-11.9,9.7-21.7,21.7-21.7s21.7,9.7,21.7,21.7-9.7,21.6-21.7,21.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M59.7,19.8l-9.6,9.6-3.1-3.1c-1.2-1.2-3.2-1.2-4.4,0-1.2,1.2-1.2,3.2,0,4.4l5.3,5.3c.6.6,1.4.9,2.2.9s1.6-.3,2.2-.9l11.8-11.8c1.2-1.2,1.2-3.2,0-4.4-1.2-1.2-3.2-1.2-4.4,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M97.7,20.8h73.8c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1h-73.8c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M97.7,41.2h48c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1h-48c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M53.3,72.1c-15.4,0-27.9,12.5-27.9,27.9,0,15.4,12.5,27.9,27.9,27.9s27.9-12.5,27.9-27.9-12.5-27.9-27.9-27.9ZM53.3,121.7c-11.9,0-21.7-9.7-21.7-21.6,0-11.9,9.7-21.7,21.7-21.7s21.7,9.7,21.7,21.7-9.7,21.6-21.7,21.6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M59.7,91.9l-9.6,9.6-3.1-3.1c-1.2-1.2-3.2-1.2-4.4,0-1.2,1.2-1.2,3.2,0,4.4l5.3,5.3c.6.6,1.4.9,2.2.9s1.6-.3,2.2-.9l11.8-11.8c1.2-1.2,1.2-3.2,0-4.4-1.2-1.2-3.2-1.2-4.4,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M171.5,86.7h-73.8c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h73.8c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M97.7,113.3h48c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1h-48c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M53.3,144.2c-15.4,0-27.9,12.5-27.9,27.9,0,15.4,12.5,27.9,27.9,27.9s27.9-12.5,27.9-27.9-12.5-27.9-27.9-27.9ZM53.3,193.7c-11.9,0-21.7-9.7-21.7-21.6,0-11.9,9.7-21.7,21.7-21.7s21.7,9.7,21.7,21.7-9.7,21.6-21.7,21.6Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M59.7,164l-9.6,9.6-3.1-3.1c-1.2-1.2-3.2-1.2-4.4,0-1.2,1.2-1.2,3.2,0,4.4l5.3,5.3c.6.6,1.4.9,2.2.9s1.6-.3,2.2-.9l11.8-11.8c1.2-1.2,1.2-3.2,0-4.4-1.2-1.2-3.2-1.2-4.4,0Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M171.5,158.8h-73.8c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h73.8c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.7,179.2h-48c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h48c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1Z"
  })));
};
export default SvgTickList;